const errorCodeForPendingProvider = '100'

export function parseAstuteHoldings(holdings) {
  const returnedHoldings = holdings.filter((holding) => !holding.error_code)

  const erroredHoldings = holdings.filter(
    (holding) =>
      holding.error_code && holding.error_code != errorCodeForPendingProvider
  )

  const pendingHoldings = holdings.filter(
    (holding) =>
      holding.error_code && holding.error_code == errorCodeForPendingProvider
  )

  return [returnedHoldings, erroredHoldings, pendingHoldings]
}

export function filterImportableAssets(holdings, assetMappings, last_response_date) {
  let importable = []
  let nonImportable = []

  for (let i = 0; i < holdings.length; i++) {
    let holding = holdings[i]
    if (assetMappings[holding.asset_type]) {
      importable.push({...holding, response_date: last_response_date})
      continue
    }
    nonImportable.push(holding)
  }

  return [importable, nonImportable]
}
